import { createMutation, request } from '@luna/api';

import { getBankMessagesUrl } from '../BankMessagesService';

export const [useMarkAllMessagesAsRead] = createMutation({
    name: 'bank-messages/action',
    payloadCreator: () => {
        return request.put(`${getBankMessagesUrl()}/action`, {
            action: 'MARK_ALL_UNREAD_AS_READ',
        });
    },
});
